module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-apache-01-m-jp.ecebb08657f13953aa942ff60fdb37fd.png";